import { uploadFileToBase64String } from "../../../../../common/utils/utils";
import { NovosNegociosForm } from "../../../presentation/schemas/Novos_negocios_cadastro/novosNegociosCadastro";
import { ICreateNovosNegociosUseCase } from "../../../presentation/useCases/create/create_novos_negocios_use_case";
import { NovosNegocios } from "../../models/novos_negocios";
import { IComercialRepository } from "../../repositories/comercial_repositories";

/**
 * CreateNovosNegociosUseCase
 */

export class CreateNovosNegociosUseCase implements ICreateNovosNegociosUseCase {
  constructor(private readonly repository: IComercialRepository) { }

  async execute(form: NovosNegociosForm): Promise<number> {
    return this.repository.createNovosNegocios(
      {
        nrNegocio: Number(form.nrNegocio) ?? undefined,
        idCliente: form.idCliente ?? undefined,
        idFuncionario: form.idFuncionario ?? undefined,
        dataSituacao: form.dataSituacao ?? undefined,
        telefone: form.telefone ?? undefined,
        titulo: form.titulo ?? undefined,
        idCentroCusto: form.idCentroCusto ?? undefined,
        nProposta: form.nProposta ?? undefined,
        nEdital: form.nEdital ?? undefined,
        possivelEscopo: form.possivelEscopo ?? undefined,
        viavelFinanc: form.viavelFinanc ?? undefined,
        idNovosNegocios: undefined,
        possivelPrazos: form.possivelPrazos ?? undefined,
        possivelReqLegais: form.possivelReqLegais ?? undefined,
        comentarios: form.comentarios ?? undefined,
        situacaoProposta: form.situacaoProposta ?? undefined,
        statusParticipar: form.statusParticipar ?? undefined,
        outros: form.outros ?? undefined,
        observacao: form.observacao ?? undefined,
        dataCriacao: form.dataCriacao ?? undefined,
        data: form.data ?? undefined,
        cidade: form.cidade ?? undefined,
        dadosCliente: form.dadosCliente ?? undefined,

        arquivo: form.arquivo ? await uploadFileToBase64String(form.arquivo) : undefined,
        nomeArquivo: form.arquivo ? form.arquivo.name : undefined,
      }
    );

  }
}
